// extracted by mini-css-extract-plugin
export default {"page":"Kxm6mY","toolbar":"_3NNfk","search":"ej41Rk","viewToggle":"KCT9lU","active":"a92PPD","addButton":"Cgj5zr","loading":"UQL8fe"};